import { SortEquipmentRequestColumnsEnum } from "./sort-equipment-request-columns.enum";
import { SortDirectionEnum } from "../spor-equipmnts/sort-direction.enum";
import { EquipmentRequestListSortOrder } from "./equipmentRequestListSortOrder";

/**
 * Преобразует формат сортировки из enum в формат TypeORM для EquipmentRequestEntity
 * 
 * @param sortOrderModel - объект сортировки в формате { [SortEquipmentRequestColumnsEnum]: SortDirectionEnum }
 * @returns объект в формате TypeORM для передачи в GraphQL запрос
 * 
 * @example
 * // Входной формат:
 * { "request.name": "ASC" }
 * 
 * // Выходной формат:
 * { name: "ASC" }
 * 
 * @example
 * // Входной формат:
 * { "sportObject.name": "ASC" }
 * 
 * // Выходной формат:
 * { sportObject: { name: "ASC" } }
 */
export function buildEquipmentRequestOrderBy(sortOrderModel: EquipmentRequestListSortOrder): Record<string, any> | undefined {
  if (!sortOrderModel || Array.isArray(sortOrderModel) || typeof sortOrderModel !== 'object') {
    return undefined;
  }

  const result: Record<string, any> = {};

  // Проходим по всем ключам в sortOrderModel
  for (const [column, direction] of Object.entries(sortOrderModel)) {
    if (!direction) continue; // Пропускаем null/undefined значения

    const directionUpper = direction.toUpperCase() as SortDirectionEnum;

    // Маппинг enum значений на формат TypeORM
    result[column] = directionUpper;
  }

  // Возвращаем undefined если объект пустой
  return Object.keys(result).length > 0 ? result : undefined;
}

